<template>
    <div class='bg-white px-3 index'>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="常用语" name="first">
                <yu />
            </el-tab-pane>
            <el-tab-pane label="常用图片" name="second">
                <yu :type="2" />
            </el-tab-pane>
            <el-tab-pane label="常用链接" name="third">
                <yu :type="3" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import yu from "./components/yu.vue";
    export default {
        components: {
            yu
        },
        data() {
            return {
                activeName: 'first'
            };
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {},
        methods: {
            handleClick(tab, event) {}
        },
    };
</script>
<style lang="scss" scoped>
    .index {}
</style>